module.exports = __webpack_public_path__ + "img/icon10.2fc20ac4.png";